import { NavLink } from "react-router-dom";
import { Home, FileText, ShoppingCart, Users, Settings } from "lucide-react";
import { cn } from "@/lib/cn";

const items = [
  { to: "/", label: "Home", icon: Home, exact: true },
  { to: "/invoices", label: "Invoices", icon: FileText },
  { to: "/purchases", label: "Purchases", icon: ShoppingCart },
  { to: "/clients", label: "Clients", icon: Users },
  { to: "/settings", label: "Settings", icon: Settings },
];

export function BottomTabBar() {
  return (
    <nav
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-surface/95 backdrop-blur border-t border-[var(--color-border)] pb-safe"
      aria-label="Primary"
    >
      <ul className="grid grid-cols-5">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <li key={it.to}>
              <NavLink
                to={it.to}
                end={it.exact}
                className={({ isActive }) =>
                  cn(
                    "relative flex flex-col items-center justify-center pt-2 pb-1.5 text-[11px] font-medium min-h-[56px] transition",
                    isActive
                      ? "text-teal-500"
                      : "text-[var(--color-text-muted)]",
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    {isActive ? (
                      <span className="absolute top-0 left-1/2 -translate-x-1/2 h-0.5 w-8 rounded-b-full bg-teal-500" />
                    ) : null}
                    <Icon size={20} aria-hidden />
                    <span className="mt-0.5">{it.label}</span>
                  </>
                )}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
